import React from 'react';
// import WalletRound from './../assets/img/wallet-round.png';


function PricingPlans(props) {

    return (
        <>
            <div className="modal fade" id="PricingPlansModal" tabIndex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true" data-bs-backdrop='static'>
                <div className="modal-dialog modal-xl" role="document">
                    <div className="modal-content">

                        <div className="modal-body">
                            <div className="text-center">
                                <h3 className="text-h3 mb-3 mt-3">Pricing Plans</h3>
                                <p className="mb-0">
                                    Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.
                                </p>
                            </div>

                            <div className="row mt-5">
                                <div className="col-sm-3"></div>
                                <div className="col-sm-6">
                                    <div className="card border-primary border shadow-none">
                                        <div className="card-body position-relative pt-4">
                                            {/* <div className="position-absolute end-0 me-5 top-0 mt-4">
                                                <span className="bg-label-primary rounded-1">Popular</span>
                                            </div> */}
                                            <div className="my-4 text-center">
                                                {/* <img src={WalletRound} alt="Pro Image" width="100" /> */}
                                            </div>
                                            <h4 className="card-title text-center text-capitalize mb-4">Standard</h4>
                                            {/* <p className="text-center mb-5">For small to medium businesses</p> */}
                                            <div className="text-center h-px-50">
                                                <div className="d-flex justify-content-center">
                                                    <sup className="h6 text-body pricing-currency mt-2 mb-0 me-1">$</sup>
                                                    <h1 className="price-toggle price-yearly text-primary mb-0">7</h1>
                                                    <h1 className="price-toggle price-monthly text-primary mb-0 d-none">9</h1>
                                                    <sub className="h6 text-body pricing-duration mt-auto mb-1 ms-1">/month</sub>
                                                </div>
                                                {/* <small className="price-yearly price-yearly-toggle text-muted">USD 480 / year</small> */}
                                            </div>

                                            <ul className="list-group my-5 pt-9">
                                                <li className="mb-4 d-flex align-items-center">
                                                    <span className="p-50 w-px-20 h-px-20 rounded-pill bg-label-primary me-2">
                                                        <i className="bx bx-check bx-xs" style={{ "paddingLeft": "2px", "paddingBottom" : "5px" }}></i>
                                                    </span>
                                                    <span>Unlimited responses</span>
                                                </li>
                                                <li className="mb-4 d-flex align-items-center">
                                                    <span className="p-50 w-px-20 h-px-20 rounded-pill bg-label-primary me-2">
                                                        <i className="bx bx-check bx-xs" style={{ "paddingLeft": "2px", "paddingBottom" : "5px" }}></i>
                                                    </span>
                                                    <span>Unlimited forms and surveys</span>
                                                </li>
                                                <li className="mb-4 d-flex align-items-center">
                                                    <span className="p-50 w-px-20 h-px-20 rounded-pill bg-label-primary me-2">
                                                        <i className="bx bx-check bx-xs" style={{ "paddingLeft": "2px", "paddingBottom" : "5px" }}></i>
                                                    </span>
                                                    <span>Instagram profile page</span>
                                                </li>
                                                <li className="mb-4 d-flex align-items-center">
                                                    <span className="p-50 w-px-20 h-px-20 rounded-pill bg-label-primary me-2">
                                                        <i className="bx bx-check bx-xs" style={{ "paddingLeft": "2px", "paddingBottom" : "5px" }}></i>
                                                    </span>
                                                    <span>Google Docs integration</span>
                                                </li>
                                                <li className="mb-0 d-flex align-items-center">
                                                    <span className="p-50 w-px-20 h-px-20 rounded-pill bg-label-primary me-2">
                                                        <i className="bx bx-check bx-xs" style={{ "paddingLeft": "2px", "paddingBottom" : "5px" }}></i>
                                                    </span>
                                                    <span>Custom “Thank you” page</span>
                                                </li>
                                            </ul>
                                            <a href="payment-page.html" className="btn btn-primary d-grid w-100">Upgrade</a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/* <div className="modal-footer">
                            <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">No</button>
                            <button onClick={remove_row.bind(this)} data-bs-dismiss="modal" className="btn btn-primary">Yes</button>
                        </div> */}
                    </div>
                </div>
            </div>
        </>
    );
}

export default PricingPlans;